<vt-styled-authorization-page [content]="welcome"></vt-styled-authorization-page>

<ng-template #welcome>
    <vt-welcome></vt-welcome>
</ng-template>